import { render, staticRenderFns } from "./TalkDashboard.vue?vue&type=template&id=22077728&scoped=true"
import script from "./TalkDashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TalkDashboard.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TalkDashboard.vue?vue&type=style&index=0&id=22077728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22077728",
  null
  
)

export default component.exports